require('./cart-delivery-tip.scss');
var BaseViews = require('../../base');
var TipButtonToggle = require('./cart-delivery-tip/cart-delivery-tip-button-toggle');
var TipCollection = require('../../../entities/cart').TipCollection;
var CartDeliveryTip = BaseViews.LayoutView.extend({
    className: 'fmcy-cart-delivery-tip',
    initialize: function (options) {
        var self = this;
        self.options = _.defaults(
            options || {},
            {
                _appChannel: null,
                expandedDetails: true,
                selectedValue: 0.15 
            }
        );
    },
    ui: {
        expandedDetails: '.fmcy-cart-tip-expanded-details',
        arrow: '.fmcy-cart-tip-arrow'
    },
    regions: {
        buttonToggleRegion: '.fmcy-cart-delivery-tip-button-toggle-region'
    },
    template: require('./cart-delivery-tip/cart-delivery-tip.html'),
    renderButtonToggle: function () {
        var self = this;
        this.tipButtonToggle = new TipButtonToggle({
            selectedValue: this.options.selectedValue,
            collection: TipCollection
        });
        this.tipButtonToggle.on('tip:selected', function (value) {
            self.model.set('deliveryTipPercentage', value);
            self.tipButtonToggle.options.selectedValue = value;
            self.tipButtonToggle.render();
            self.trigger('update');
        });

        this.buttonToggleRegion.show(this.tipButtonToggle);
    },
    onRender: function () {
        this.renderButtonToggle();
        if (this.options.expandedDetails == true) {
            this.ui.expandedDetails.css('display', 'block');
            this.ui.arrow.css('display', 'none');
        } else {
            this.ui.expandedDetails.css('display', 'none');
            this.ui.arrow.css('display', 'block');
            this.$el.addClass('fmcy-cart-tip-below')
        }
        BaseViews.LayoutView.prototype.onRender.call(this);
    }
});
module.exports = CartDeliveryTip;


/** WEBPACK FOOTER **
 ** ./assets/js/common/cart/cart-delivery-address/cart-delivery-tip.js
 **/